import { gql, useQuery } from '@apollo/client';
import { useSites } from 'store'

const OPERATION_PHONE_NUMBERS_QUERY = gql`
  query VoipPhoneNumbers($siteSfId: ID!) {
    phoneNumbers: voipPhoneNumbers(site_sf_id: $siteSfId) {
      number
      country_code
      activation_date
      destination_type
      destination
      context
    }
  }
`

const OPERATION_KPIS = gql`
  query VoipStatsSIPs($siteSfId: ID!) {
    kpis: voipStatsSIPs(site_sf_id: $siteSfId) {
      administrative_up
      administrative_down
      room_up
      room_down
    }
  }
`

const OPERATION_STATS = gql`
  query VoipStatsCDRs($siteSfId: ID!, $startAt: String!, $endAt: String, $scale: String, $queue: String) {
    stats: voipStatsCDRs(site_sf_id: $siteSfId, start_at: $startAt, end_at: $endAt, scale: $scale, queue: $queue) {
      count_call_success
      count_call_failure
      percent_call_success
      percent_call_failure
      percent_transfer
      count_outgoing_call
      average_waiting_duration
      average_call_duration
      queue_names
      graph {
        date
        count_call_success
        count_call_failure
      }
    }
  }
`

export const useStats = ({startAt, endAt, scale, queue}) => {
  const [{selected}] = useSites()
  const { data, loading, error } = useQuery(OPERATION_STATS, {
    variables: {
      siteSfId: selected[0].sf_id,
      startAt: startAt.format('yyyy-MM-DD 00:00:00'),
      endAt: endAt.format('yyyy-MM-DD 23:59:59'),
      scale,
      queue
    }, fetchPolicy: 'network-only'
  })

  return {
    loading,
    error,
    stats: data?.stats || {}
  }
}

export const useKpis = () => {
  const [{selected}] = useSites()
  const {data, loading, error} = useQuery(OPERATION_KPIS, {
    variables: {
      siteSfId: selected[0].sf_id,
    }, fetchPolicy: 'network-only'
  })

  return {
    loading,
    error,
    kpis: data?.kpis || {  }
  }
}
export const usePhoneNumbers = () => {
  const [{selected}] = useSites()
  const {data, loading, error} = useQuery(OPERATION_PHONE_NUMBERS_QUERY, {
    variables: {
      siteSfId: selected[0].sf_id,
    }, fetchPolicy: 'network-only'
  })

  return {
    loading,
    error,
    phoneNumbers: data?.phoneNumbers || []
  }
}

